import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { GoogleDriveConnector } from '../../connector';

export const GoogleDriveService = IntegrationService.make({
  connector: GoogleDriveConnector,
  name: Integration_Service_Names_Enum.GoogleDrive,
});
